import React, { useState, useEffect } from 'react';
import ApiService from '../services/api';
import {
    MonitorCog , SquareActivity , Tickets ,Receipt , Briefcase,
    Menu,
    X,
    Home,
    Package,
    FileText,
    Calendar,
    Users,
    BarChart3,
    Settings,
    Bell,
    Search,
    ChevronDown,
    ArrowRight,
    TrendingUp,
    TrendingDown,
    Building,
    Hammer,
    Truck,
    Star,
    AlertCircle,
    CheckCircle,
    Clock,
    DollarSign,
    Activity,
    Globe,
    Zap,
    Target,
    Award,
    Shield,
    LogOut,
    ChevronRight,
    Filter,
    Download,
    RefreshCw,
    MoreVertical,
    Plus,
    User,
    Edit,
    Trash2,
    Eye,
    Package2,
    Layers,
    Wrench,
    ShoppingCart,
    Box,
    Hash,
    Cable,
    Grid,
    Cpu,
    Router,
    Network,
    HardDrive,
    Server,
    MonitorSpeaker,
    Radio,
    Wifi,
    Database,
    CircuitBoard,
    Power,
    PlugZap,
    UserCog,
    Calculator,
    Construction,
    Beaker,
    Leaf,
    ShieldCheck,
    Folder
} from 'lucide-react';
import '../Styles/products.css';
import { useNavigate } from "react-router-dom";
import MepIcon from '../assets/MEP_Solutions.png';
import architecturalIcon from '../assets/architectural_icon.png';
import civilIcon from '../assets/civil-icon.png';
import constructionIcon from '../assets/construction-icon.png';
import powerToolsIcon from '../assets/power-tools_icon.png';
import sustainableIcon from '../assets/sustainable-icon.png';
import hygienicIcon from '../assets/hygienic-icon.png';
import '../Styles/dashboard.css';
import * as XLSX from 'xlsx';


const UnitechCableManagementPage = () => {
    const [user, setUser] = useState(null);
    const [isAuthChecking, setIsAuthChecking] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [activeMenuItem, setActiveMenuItem] = useState('planning');
    const [currentTime, setCurrentTime] = useState(new Date());
    const [notifications, setNotifications] = useState(3);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('name');
    const [sortOrder, setSortOrder] = useState('asc');
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedCableProduct, setSelectedCableProduct] = useState(null);
    const navigate = useNavigate();

    const [cableProducts, setCableProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        pages: 1,
        total: 0
    });
    const [error, setError] = useState(null);

    const [showAddModal, setShowAddModal] = useState(false);
    const [formData, setFormData] = useState({
        barcodeNumber: '',
        productNumber: '',
        category: 'cable_trays_accessories',
        description: '',
        standard: 'BS_EN_61537'
    });
    const [formError, setFormError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        loadCurrentUser();
    }, []);

    useEffect(() => {
        if (user) {
            loadCategories();
            loadCableProducts();
        }
    }, [user]);

useEffect(() => {
    if (user) {
        // Reset pagination when search/sort/category changes
        setPagination(prev => ({ ...prev, page: 1 }));
        
        const timeoutId = setTimeout(() => {
            loadCableProducts();
        }, searchTerm ? 300 : 100);
        
        return () => clearTimeout(timeoutId);
    }
}, [user, selectedCategory, searchTerm, sortBy, sortOrder]);

useEffect(() => {
    if (user && pagination.page) {
        console.log('🔄 Cable pagination page changed to:', pagination.page);
        loadCableProducts();
    }
}, [pagination.page]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const loadCurrentUser = async () => {
        try {
            setIsAuthChecking(true);
            
            const syncUser = ApiService.getUserSync();
            if (syncUser) {
                setUser(syncUser);
                setIsAuthChecking(false);
                return;
            }

            const response = await ApiService.getCurrentUser();
            if (response.success && response.user) {
                setUser(response.user);
            } else {
                navigate('/login');
            }
        } catch (error) {
            console.error('Failed to load user:', error);
            navigate('/login');
        } finally {
            setIsAuthChecking(false);
        }
    };

    const loadCategories = async () => {
        try {
            const response = await ApiService.getCableCategories();
            if (response.success) {
                setCategories(response.categories);
            }
        } catch (error) {
            console.error('Failed to load cable categories:', error);
            setCategories([
                { id: 'all', name: 'Tous les produits', count: 0 },
                { id: 'cable_trays_accessories', name: 'Cable Trays & Accessories', count: 0 },
                { id: 'cable_ladders_welded_swaged', name: 'Cable Ladders (Welded & Swaged)', count: 0 },
                { id: 'basket_trays_accessories', name: 'Basket Trays & Accessories', count: 0 },
                { id: 'cable_trunkings', name: 'Cable Trunkings', count: 0 },
                { id: 'underfloor_trunkings', name: 'Underfloor Trunkings', count: 0 },
                { id: 'fiberglass_frp_cable_tray_ladder', name: 'FiberGlass Reinforced Plastic FRP Cable Tray/Ladder', count: 0 },
                { id: 'weatherproof_cable_trunk', name: 'Weatherproof Cable Trunk', count: 0 },
                { id: 'cable_management_support_systems', name: 'Cable Management Support Systems', count: 0 }
            ]);
                    }
                };

const loadCableProducts = async () => {
    try {
        setIsLoading(true);
        setError(null);
        
        const params = {
            category: selectedCategory !== 'all' ? selectedCategory : undefined,
            search: searchTerm.trim() || undefined,
            sortBy,
            sortOrder,
            page: pagination.page || 1,  // Ensure page is always set
            limit: 20  // Add consistent limit
        };

        // Remove undefined params
        Object.keys(params).forEach(key => {
            if (params[key] === undefined) {
                delete params[key];
            }
        });

        console.log('🔄 Loading cable products with params:', params);

        const response = await ApiService.getCableProducts(params);
        
        console.log('📡 Cable API Response:', response);
        
        if (response.success || response.products || response.data) {
            let productsArray = [];
            
            // Handle different response formats
            if (Array.isArray(response.products)) {
                productsArray = response.products;
            } else if (Array.isArray(response.data)) {
                productsArray = response.data;
            } else if (Array.isArray(response)) {
                productsArray = response;
            }
            
            console.log('📦 Cable products found:', productsArray.length);
            console.log('📄 Current page:', pagination.page);
            
            setCableProducts(productsArray);
            
            // Update pagination - be more careful with the calculation
            const total = response.total || response.count || productsArray.length;
            const limit = response.limit || params.limit || 20;
            const pages = Math.max(1, Math.ceil(total / limit));
            
            console.log('📊 Cable pagination info - Total:', total, 'Limit:', limit, 'Pages:', pages);
            
            setPagination(prev => ({
                ...prev,
                total: total,
                pages: pages,
                limit: limit
                // Don't update page here - only update page from user actions
            }));
            
            setError(null);
        } else {
            console.error('❌ Cable API Error:', response.message || 'Unknown error');
            setCableProducts([]);
            setPagination(prev => ({ ...prev, total: 0, pages: 1 }));
            setError(response.message || "Erreur lors du chargement des produits de câblage");
        }
    } catch (error) {
        console.error('💥 Load cable products error:', error);
        setCableProducts([]);
        setError(error.message || "Erreur lors du chargement des produits de câblage");
        setPagination(prev => ({ ...prev, total: 0, pages: 1 }));
    } finally {
        setIsLoading(false);
    }
};

    const handleRefresh = () => {
        loadCableProducts();
        loadCategories();
    };

    const openAddModal = () => {
        setShowAddModal(true);
        setFormError('');
        setFormData({
            barcodeNumber: '',
            productNumber: '',
            category: 'cable_trays_accessories',
            description: '',
            standard: 'BS_EN_61537'
        });
    };


    const closeAddModal = () => {
        setShowAddModal(false);
        setFormError('');
        setFormData({
            barcodeNumber: '',
            productNumber: '',
            category: 'cable_trays_accessories',
            description: '',
            standard: 'BS_EN_61537'
        });
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddCableProduct = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormError('');

    try {
        if (!formData.barcodeNumber || !formData.productNumber || !formData.description) {
            throw new Error('Veuillez remplir tous les champs obligatoires');
        }

        const productData = {
            barcodeNumber: formData.barcodeNumber,
            productNumber: formData.productNumber,
            category: formData.category,
            description: formData.description,
            standard: formData.standard
        };

        const response = await ApiService.createCableProduct(productData);
        
        if (response.success) {
            alert('Produit créé avec succès ! 🎉');
            closeAddModal();
            loadCableProducts();
            loadCategories();
        }
    } catch (error) {
        setFormError(error.message || 'Erreur lors de la création du produit');
    } finally {
        setIsSubmitting(false);
    }
};


    const handleDeleteCableProduct = async (productId) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer ce produit de câblage ?')) {
            try {
                setIsLoading(true);
                const response = await ApiService.deleteCableProduct(productId);
                if (response.success) {
                    loadCableProducts();
                    loadCategories();
                    alert('Produit supprimé avec succès');
                }
            } catch (error) {
                console.error('Failed to delete cable product:', error);
                alert('Erreur lors de la suppression du produit: ' + error.message);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleLogout = async () => {
        if (window.confirm('Are you sure you wanna disconnect?')) {
            // Nettoyer les données utilisateur
            ApiService.clearUserData();
            
            // Utiliser React Router pour naviguer vers login
            navigate('/login');
        }
    };



const menuItems = [
    { 
        id: 'barcoding', 
        label: 'Barcoding Database', 
        icon: FileText, // Keep as Lucide icon
        path: '/barcoding' 
    },
    { 
        id: 'mep-solutions', 
        label: 'MEP Solutions', 
        icon: MepIcon, // 🔄 Replace with image
        isImage: true,
        path: '/mep_solutions' 
    },
    { 
        id: 'architectural-solutions', 
        label: 'Architectural Solutions', 
        icon: architecturalIcon , // 🔄 Replace with image
        isImage: true,
        path: '/architectural_solutions' 
    },
    { 
        id: 'civil-solutions', 
        label: 'Civil Solutions', 
        icon: civilIcon, // 🔄 Replace with image
        isImage: true,
        path: '/civil_solutions' 
    },
    { 
        id: 'construction-chemicals', 
        label: 'Construction Chemicals', 
        icon: constructionIcon, // 🔄 Replace with image
        isImage: true,
        path: '/construction_chemicals' 
    },
    { 
        id: 'power-tools', 
        label: 'Power & Industrial Tools', 
        icon: powerToolsIcon, // 🔄 Replace with image
        isImage: true,
        path: '/power_tools' 
    },
    { 
        id: 'sustainable-solutions', 
        label: 'Sustainable Solutions', 
        icon: sustainableIcon, // 🔄 Replace with image
        isImage: true,
        path: '/sustainable_solutions' 
    },
    { 
        id: 'hygienic-solutions', 
        label: 'Hygienic Solutions', 
        icon: hygienicIcon, // 🔄 Replace with image
        isImage: true,
        path: '/hygienic_solutions' 
    },
    { 
        id: 'conversions', 
        label: 'Engineering Conversions', 
        icon: Calculator, // Keep as Lucide icon
        path: '/conversion' 
    },
    { 
        id: 'analytics', 
        label: 'Amazon Products', 
        icon: BarChart3, // Keep as Lucide icon
        path: '/amazon_products' 
    },
    { 
        id: 'team', 
        label: 'Team Management', 
        icon: Users, // Keep as Lucide icon
        path: '/team_management' 
    },
    { 
        id: 'user-management', 
        label: 'User Management', 
        icon: UserCog, // Keep as Lucide icon
        path: '/users_management' 
    },
];

    const filteredMenuItems = menuItems.filter(item => {
        if (item.id === 'team' && user?.role === 'user') return false;
        if (item.id === 'settings' && user?.role !== 'admin') return false;
        return true;
    });

    const getUserInitials = () => {
        if (!user) return 'U';
        const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
        const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
        return firstInitial + lastInitial || user.email.charAt(0).toUpperCase();
    };

    const getDisplayName = () => {
        if (!user) return 'Utilisateur';
        if (user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        return user.email;
    };

    const getStatusBadge = (status, stock, minStock) => {
        if (status === 'low_stock' || stock <= minStock) {
            return { text: 'Stock Faible', class: 'status-low-stock' };
        } else if (status === 'out_of_stock' || stock === 0) {
            return { text: 'Rupture', class: 'status-out-of-stock' };
        } else {
            return { text: 'Disponible', class: 'status-available' };
        }
    };

const getCategoryIcon = (categoryId) => {
    const iconMap = {
        'all': Grid,
        'cable_trays_accessories': Package2,
        'cable_ladders_welded_swaged': Layers,
        'basket_trays_accessories': Grid,
        'cable_trunkings': Box,
        'underfloor_trunkings': HardDrive,
        'fiberglass_frp_cable_tray_ladder': Cpu,
        'weatherproof_cable_trunk': Shield,
        'cable_management_support_systems': Wrench
    };
    return iconMap[categoryId] || Cable;
};

        const categoryOptions = [
            { value: 'cable_trays_accessories', label: 'Cable Trays & Accessories' },
            { value: 'cable_ladders_welded_swaged', label: 'Cable Ladders (Welded & Swaged)' },
            { value: 'basket_trays_accessories', label: 'Basket Trays & Accessories' },
            { value: 'cable_trunkings', label: 'Cable Trunkings' },
            { value: 'underfloor_trunkings', label: 'Underfloor Trunkings' },
            { value: 'fiberglass_frp_cable_tray_ladder', label: 'FiberGlass Reinforced Plastic FRP Cable Tray/Ladder' },
            { value: 'weatherproof_cable_trunk', label: 'Weatherproof Cable Trunk' },
            { value: 'cable_management_support_systems', label: 'Cable Management Support Systems' }
        ];


    const materialOptions = [
        'galvanized_steel', 'stainless_steel', 'aluminum', 'pvc', 'fiberglass', 'carbon_steel'
    ];

    const finishOptions = [
        'pre_galvanized', 'hot_dip_galvanized', 'stainless_steel', 'aluminum', 'plastic_coated'
    ];

const standardOptions = [
    'BS_EN_61537', 'NEMA', 'IEC_61537', 'ASTM_A123', 'ISO_11801', 'UL_2239'
];

    if (isAuthChecking) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                flexDirection: 'column'
            }}>
                <RefreshCw style={{ width: '24px', height: '24px', animation: 'spin 1s linear infinite' }} />
                <p style={{ marginTop: '16px' }}>Vérification de l'authentification...</p>
            </div>
        );
    }


    if (!user) {
        return null;
    }

    const openViewModal = (product) => {
        setSelectedCableProduct(product);
        setShowViewModal(true);
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setSelectedCableProduct(null);
    };

    const openEditModal = (product) => {
        setSelectedCableProduct(product);
        setFormData({
            barcodeNumber: product.barcodeNumber,
            productNumber: product.productNumber,
            category: product.category,
            description: product.description || '',
            standard: product.standard || 'BS_EN_61537'
        });
        setFormError('');
        setShowEditModal(true);
    };

    const closeEditModal = () => {
        setShowEditModal(false);
        setSelectedCableProduct(null);
        setFormError('');
    };

    // Add this new function after handleEditCableProduct
    const handleExportCableProducts = async () => {
        try {
            setIsLoading(true);
            alert('Preparing cable products export...');

            // Prepare export parameters
            const exportParams = {
                category: selectedCategory !== 'all' ? selectedCategory : undefined,
                search: searchTerm.trim() || undefined,
                sortBy,
                sortOrder,
                export: true, // Flag to get all data, not paginated
                limit: 10000 // Get maximum records for export
            };

            // Remove undefined values
            Object.keys(exportParams).forEach(key => {
                if (exportParams[key] === undefined) {
                    delete exportParams[key];
                }
            });

            // Get all cable products for export
            const response = await ApiService.getCableProducts(exportParams);

            if (response.success || response.products || response.data) {
                let productsToExport = [];

                // Handle different response formats
                if (Array.isArray(response.products)) {
                    productsToExport = response.products;
                } else if (Array.isArray(response.data)) {
                    productsToExport = response.data;
                } else if (Array.isArray(response)) {
                    productsToExport = response;
                }

                // Prepare data for export
                const exportData = productsToExport.map((product, index) => ({
                    'No.': index + 1,
                    'Barcode Number': product.barcodeNumber || '',
                    'Product Number': product.productNumber || '',
                    'Category': categoryOptions.find(c => c.value === product.category)?.label || product.category || '',
                    'Standard': product.standard?.replace('_', ' ') || '',
                    'Description': product.description || '',
                    'Created Date': product.createdAt ? new Date(product.createdAt).toLocaleDateString('fr-FR') : '',
                    'Last Updated': product.updatedAt ? new Date(product.updatedAt).toLocaleDateString('fr-FR') : ''
                }));

                // Create and download Excel file
                await exportCableProductsToExcel(exportData, productsToExport.length);

            } else {
                throw new Error('No cable products data to export');
            }
        } catch (error) {
            console.error('Cable export failed:', error);
            alert('Export failed: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

// Add this helper function for Excel export
    const exportCableProductsToExcel = async (data, totalCount) => {
        try {
            // Create workbook and worksheet
            const ws = {};
            const headers = Object.keys(data[0] || {});

            // Add headers
            headers.forEach((header, index) => {
                const cellRef = String.fromCharCode(65 + index) + '1';
                ws[cellRef] = { v: header, t: 's' };
            });

            // Add data rows
            data.forEach((row, rowIndex) => {
                headers.forEach((header, colIndex) => {
                    const cellRef = String.fromCharCode(65 + colIndex) + (rowIndex + 2);
                    const value = row[header];
                    ws[cellRef] = { v: value, t: typeof value === 'number' ? 'n' : 's' };
                });
            });

            // Set worksheet range
            const range = `A1:${String.fromCharCode(65 + headers.length - 1)}${data.length + 1}`;
            ws['!ref'] = range;

            // Create workbook
            const wb = {
                Sheets: { 'Cable Products': ws },
                SheetNames: ['Cable Products']
            };

            // Generate Excel file
            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

            // Create and download file
            const blob = new Blob([wbout], { type: 'application/octet-stream' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            // Generate filename with current date and filter info
            const today = new Date().toISOString().split('T')[0];
            const categoryText = selectedCategory === 'all' ? 'All-Categories' : selectedCategory.replace(/_/g, '-');
            const filename = `UNITECH-Cable-Products_${categoryText}_${today}.xlsx`;

            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            // Show success notification
            const filterText = selectedCategory === 'all' ? 'all cable products' :
                categories.find(c => c.id === selectedCategory)?.name || selectedCategory;
            alert(`Successfully exported ${totalCount} cable products (${filterText}) to Excel! 🎉`);

        } catch (error) {
            console.error('Excel generation failed:', error);
            throw new Error('Failed to generate Excel file');
        }
    };
    const handleEditCableProduct = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.barcodeNumber || !formData.productNumber || !formData.description) {
                throw new Error('Veuillez remplir tous les champs obligatoires');
            }

            const productData = {
                barcodeNumber: formData.barcodeNumber,
                productNumber: formData.productNumber,
                category: formData.category,
                description: formData.description,
                standard: formData.standard
            };

            const response = await ApiService.updateCableProduct(selectedCableProduct._id, productData);
            
            if (response.success) {
                alert('Produit de câblage mis à jour avec succès !');
                closeEditModal();
                loadCableProducts();
                loadCategories();
            }
        } catch (error) {
            setFormError(error.message || 'Erreur lors de la mise à jour');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="dashboard-container">
            {/* ADD CABLE PRODUCT MODAL */}
            {showAddModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        width: '90%',
                        maxWidth: '700px',
                        maxHeight: '90vh',
                        overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '24px',
                            paddingBottom: '16px',
                            borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: '#1e40af',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <Cable style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Add Cable Product
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        Create a new cable management product
                                    </p>
                                </div>
                            </div>
                            <button
                                onClick={closeAddModal}
                                style={{
                                    padding: '8px',
                                    border: 'none',
                                    background: 'none',
                                    cursor: 'pointer',
                                    borderRadius: '6px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {/* Error Message */}
                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2',
                                border: '1px solid #fecaca',
                                color: '#dc2626',
                                padding: '12px',
                                borderRadius: '8px',
                                marginBottom: '20px',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        {/* Form */}
                        <form onSubmit={showEditModal ? handleEditCableProduct : handleAddCableProduct}>
    <div style={{ display: 'grid', gap: '20px' }}>
        {/* Row 1: Barcode Number and Product Number */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div>
                <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#374151',
                    marginBottom: '6px'
                }}>
                    <Hash style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                    Numéro de Code-barres *
                </label>
                <input
                    type="text"
                    name="barcodeNumber"
                    value={formData.barcodeNumber}
                    onChange={handleInputChange}
                    placeholder="1234567890123"
                    required
                    maxLength="13"
                    pattern="[0-9]{13}"
                    title="The barcode should be a 13-digit number."
                    style={{
                        width: '100%',
                        padding: '12px',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        fontSize: '14px',
                        boxSizing: 'border-box'
                    }}
                />
            </div>

            <div>
                <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#374151',
                    marginBottom: '6px'
                }}>
                    <Package2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                    Numéro de Produit *
                </label>
                <input
                    type="text"
                    name="productNumber"
                    value={formData.productNumber}
                    onChange={handleInputChange}
                    placeholder="CT-300-100-001"
                    required
                    style={{
                        width: '100%',
                        padding: '12px',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        fontSize: '14px',
                        boxSizing: 'border-box'
                    }}
                />
            </div>
        </div>

        {/* Row 2: Category and Standard */}
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
            <div>
                <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#374151',
                    marginBottom: '6px'
                }}>
                    <Layers style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                    Catégorie *
                </label>
                <select
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                    required
                    style={{
                        width: '100%',
                        padding: '12px',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        fontSize: '14px',
                        boxSizing: 'border-box'
                    }}
                >
                    {categoryOptions.map(cat => (
                        <option key={cat.value} value={cat.value}>
                            {cat.label}
                        </option>
                    ))}
                </select>
            </div>

            <div>
                <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#374151',
                    marginBottom: '6px'
                }}>
                    <Shield style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                    Standard *
                </label>
                <select
                    name="standard"
                    value={formData.standard}
                    onChange={handleInputChange}
                    required
                    style={{
                        width: '100%',
                        padding: '12px',
                        border: '1px solid #d1d5db',
                        borderRadius: '8px',
                        fontSize: '14px',
                        boxSizing: 'border-box'
                    }}
                >
                    {standardOptions.map(standard => (
                        <option key={standard} value={standard}>
                            {standard.replace('_', ' ')}
                        </option>
                    ))}
                </select>
            </div>
        </div>

        {/* Row 3: Description */}
        <div>
            <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#374151',
                marginBottom: '6px'
            }}>
                <FileText style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                Description *
            </label>
            <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                placeholder="Detailled Description of the Product."
                required
                rows="4"
                maxLength="1000"
                style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    fontSize: '14px',
                    boxSizing: 'border-box',
                    resize: 'vertical'
                }}
            />
            <small style={{ color: '#6b7280', fontSize: '12px' }}>
                {formData.description.length}/1000 caractères
            </small>
        </div>
    </div>

    {/* Form Actions */}
    <div style={{
        display: 'flex',
        gap: '12px',
        marginTop: '24px',
        paddingTop: '20px',
        borderTop: '1px solid #e5e7eb'
    }}>
        <button
            type="button"
            onClick={showEditModal ? closeEditModal : closeAddModal}
            style={{
                flex: 1,
                padding: '12px 20px',
                border: '1px solid #d1d5db',
                background: 'white',
                color: '#374151',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer'
            }}
        >
            Cancel
        </button>
        <button
            type="submit"
            disabled={isSubmitting}
            style={{
                flex: 2,
                padding: '12px 20px',
                border: 'none',
                background: isSubmitting ? '#9ca3af' : (showEditModal ? '#f59e0b' : '#1e40af'),
                color: 'white',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
            }}
        >
            {isSubmitting ? (
                <>
                    <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                    {showEditModal ? 'Updating...' : 'Creating...'}
                </>
            ) : (
                <>
                    <Cable style={{ width: '16px', height: '16px' }} />
                    {showEditModal ? 'Update' : 'Create Product'}
                </>
            )}
        </button>
    </div>
</form>
                    </div>
                </div>
            )}

            {/* VIEW CABLE PRODUCT MODAL */}
            {showViewModal && selectedCableProduct && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '600px', maxHeight: '90vh', overflow: 'auto'
                    }}>
                        {/* Header */}
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#059669',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Eye style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                                        Cable Product Details
                                    </h2>
<p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
    {selectedCableProduct.productNumber}
</p>
                                </div>
                            </div>
                            <button onClick={closeViewModal} style={{ padding: '8px', border: 'none', background: 'none', cursor: 'pointer' }}>
                                <X style={{ width: '20px', height: '20px' }} />
                            </button>
                        </div>

                        {/* Details */}
<div style={{ display: 'grid', gap: '16px' }}>
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
        <div>
            <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CODE-BARRES</label>
            <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', fontFamily: 'monospace' }}>
                {selectedCableProduct.barcodeNumber}
            </p>
        </div>
        <div>
            <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>NUMÉRO PRODUIT</label>
            <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                {selectedCableProduct.productNumber}
            </p>
        </div>
    </div>

    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
        <div>
            <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>Category</label>
            <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                {categoryOptions.find(c => c.value === selectedCableProduct.category)?.label || selectedCableProduct.category}
            </p>
        </div>
        <div>
            <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>STANDARD</label>
            <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                {selectedCableProduct.standard?.replace('_', ' ') || 'N/A'}
            </p>
        </div>
    </div>

    <div>
        <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>DESCRIPTION</label>
        <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5' }}>
            {selectedCableProduct.description}
        </p>
    </div>

    <div>
        <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CREATED ON</label>
        <p style={{ margin: 0, fontSize: '14px' }}>
            {selectedCableProduct.createdAt ? new Date(selectedCableProduct.createdAt).toLocaleDateString('fr-FR') : 'N/A'}
        </p>
    </div>
</div>

                        <button onClick={closeViewModal} style={{
                            width: '100%', padding: '12px', marginTop: '20px',
                            border: '1px solid #d1d5db', background: 'white',
                            borderRadius: '8px', cursor: 'pointer'
                        }}>
                            Close
                        </button>
                    </div>
                </div>
            )}

            {/* EDIT CABLE PRODUCT MODAL */}
            {showEditModal && selectedCableProduct && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '700px', maxHeight: '90vh', overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Header */}
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#f59e0b',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Edit style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Modifier Produit Câblage
                                    </h2>
<p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
    {selectedCableProduct.productNumber}
</p>
                                </div>
                            </div>
                            <button onClick={closeEditModal} style={{
                                padding: '8px', border: 'none', background: 'none', cursor: 'pointer', borderRadius: '6px'
                            }}>
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {/* Error */}
                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                                color: '#dc2626', padding: '12px', borderRadius: '8px',
                                marginBottom: '20px', fontSize: '14px', display: 'flex', alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        {/* EDIT FORM - Same structure as ADD form but with edit handler */}
                        <form onSubmit={handleEditCableProduct}>
                            {/* Same form structure as ADD modal but shorter for brevity */}
<div style={{ display: 'grid', gap: '20px' }}>
    {/* Barcode and Product Number */}
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
        <div>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                <Hash style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                Barcode Number *
            </label>
            <input
                type="text" name="barcodeNumber" value={formData.barcodeNumber} onChange={handleInputChange} required
                maxLength="13" pattern="[0-9]{13}"
                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
            />
        </div>
        <div>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                <Package2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                Product Number *
            </label>
            <input
                type="text" name="productNumber" value={formData.productNumber} onChange={handleInputChange} required
                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
            />
        </div>
    </div>

    {/* Category and Standard */}
    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
        <div>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                Category *
            </label>
            <select name="category" value={formData.category} onChange={handleInputChange} required
                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                {categoryOptions.map(cat => (
                    <option key={cat.value} value={cat.value}>{cat.label}</option>
                ))}
            </select>
        </div>
        <div>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                Standard *
            </label>
            <select name="standard" value={formData.standard} onChange={handleInputChange} required
                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                {standardOptions.map(standard => (
                    <option key={standard} value={standard}>{standard.replace('_', ' ')}</option>
                ))}
            </select>
        </div>
    </div>

    {/* Description */}
    <div>
        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
            Description *
        </label>
        <textarea name="description" value={formData.description} onChange={handleInputChange} required rows="4" maxLength="1000"
            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }}
        />
        <small style={{ color: '#6b7280', fontSize: '12px' }}>
            {formData.description.length}/1000 caractères
        </small>
    </div>
</div>
                            {/* Form Actions */}
                            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #e5e7eb' }}>
                                <button type="button" onClick={closeEditModal}
                                    style={{ flex: 1, padding: '12px 20px', border: '1px solid #d1d5db', background: 'white', color: '#374151', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
                                    Cancel
                                </button>
                                <button type="submit" disabled={isSubmitting}
                                    style={{ flex: 2, padding: '12px 20px', border: 'none', background: isSubmitting ? '#9ca3af' : '#f59e0b', color: 'white', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: isSubmitting ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            Updating...
                                        </>
                                    ) : (
                                        <>
                                            <Edit style={{ width: '16px', height: '16px' }} />
                                            Update
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Sidebar */}
            <aside className="sidebar">
                    <div className="sidebar-header">
                        <div 
                            className="sidebar-logo-container"
                            onClick={() => navigate('/dashboard')}
                            style={{
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                borderRadius: '8px',
                                padding: '8px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                                e.currentTarget.style.transform = 'scale(1.02)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                                e.currentTarget.style.transform = 'scale(1)';
                            }}
                            title="Retour au Dashboard"
                        >
                            <div className="sidebar-logo">
                                <Building style={{ width: '24px', height: '24px', color: 'white' }} />
                            </div>
                            <div className="sidebar-brand">
                                <h1 className="sidebar-title">UNITECH IKK</h1>
                                <p className="sidebar-subtitle">Enterprise Dashboard</p>
                            </div>
                        </div>
                    </div>

<nav className="sidebar-nav">
  {filteredMenuItems.map((item) => (
    <div
      key={item.id}
      className={`nav-item ${activeMenuItem === item.id ? 'active' : ''}`}
      onClick={() => {
        setActiveMenuItem(item.id);
        navigate(item.path);
      }}
    >
      {item.isImage ? (
        <img 
          src={item.icon} 
          alt={item.label}
          className="nav-icon-image"
          style={{ 
            width: '20px', 
            height: '20px',
            display: 'block' // Ensures proper alignment
          }}
        />
      ) : (
        <item.icon 
          style={{ 
            width: '20px', 
            height: '20px',
            display: 'block' // Ensures consistency with images
          }} 
        />
      )}
      <span className="nav-text">{item.label}</span>
    </div>
  ))}
</nav>
                <div className="sidebar-footer">
                    <div className="user-profile">
                        <div className="user-avatar">{getUserInitials()}</div>
                        <div className="user-info">
                            <p className="user-name">{getDisplayName()}</p>
                            <p className="user-role">{user?.role || 'Utilisateur'}</p>
                        </div>
                        <button
                            className="logout-button"
                            onClick={handleLogout}
                            title="Se déconnecter"
                        >
                            <LogOut style={{ width: '16px', height: '16px' }} />
                        </button>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="main-content">
                {/* Header */}
                <header className="header">
                    <div className="header-content">
                        <div className="header-left">
                            <button
                                className="menu-toggle"
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                            >
                                {sidebarOpen ?
                                    <X style={{ width: '20px', height: '20px' }} /> :
                                    <Menu style={{ width: '20px', height: '20px' }} />
                                }
                            </button>

                            <nav className="breadcrumb">
                                <div className="breadcrumb-item">
                                    <Home style={{ width: '16px', height: '16px' }} />
                                    <span>Dashboard</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <Cable style={{ width: '16px', height: '16px' }} />
                                    <span>Cable Management</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <span>Produits</span>
                                </div>
                            </nav>
                        </div>

                    <div className="header-right">
                        <div className="search-container">
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Research..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <Search className="search-icon" style={{ width: '18px', height: '18px' }} />
                        </div>

                        <div className="header-actions">
                            <button
                                className="header-button"
                                onClick={handleRefresh}
                                disabled={isLoading}
                                title="Actualiser"
                            >
                                <RefreshCw style={{
                                    width: '18px',
                                    height: '18px',
                                    transform: isLoading ? 'rotate(360deg)' : 'none',
                                    transition: 'transform 1s linear'
                                }} />
                            </button>

                            <button 
                                className="header-button"
                                title="Notifications"
                            >
                                <Bell style={{ width: '18px', height: '18px' }} />
                                {notifications.length > 0 && (
                                    <span className="notification-badge">{notifications.length}</span>
                                )}
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/settings')}
                                title="Paramètres système"
                            >
                                <Settings style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/project_management')}
                                title="Gestion de projets"
                            >
                                <Folder style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/technical_support')}
                                title="Technical Support"
                            >
                                <MonitorCog style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/admin_support_it')}
                                title="Admin Support IT"
                            >
                                <SquareActivity style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/mytickets')}
                                title="My Tickets"
                            >
                                <Tickets style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/quotations')}
                                title="Quotation System"
                            >
                                <Receipt style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/clients')}
                                title="Clients"
                            >
                                <Briefcase style={{ width: '18px', height: '18px' }} />
                            </button>

                            <div className="time-display">
                                {currentTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                            </div>
                        </div>
                    </div>
                    </div>
                </header>

                {/* Cable Management Content */}
                <div className="products-content">
                    {/* Error Display */}
                    {error && (
                        <div className="error-message" style={{
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            padding: '12px',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                            {error}
                        </div>
                    )}

                    {/* Page Header */}
                    <div className="page-header">
                        <h1 className="page-title">Cable Management System</h1>
                        <p className="page-subtitle">
                            Manage your UNITECH IKK cable management system inventory - Cable Trays, Ladders, Supports & Accessories.
                        </p>

                        <div className="page-actions">
                            <button 
                                className="action-button"
                                onClick={openAddModal}
                                style={{ cursor: 'pointer' }}
                            >
                                <Cable style={{ width: '16px', height: '16px' }} />
                                Add Product
                            </button>
                            <button
                                className="action-button secondary"
                                onClick={handleExportCableProducts}
                                disabled={isLoading}
                                title={selectedCategory === 'all' ? 'Export all cable products' : `Export ${categories.find(c => c.id === selectedCategory)?.name || selectedCategory} products`}
                            >
                                {isLoading ? (
                                    <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                ) : (
                                    <Download style={{ width: '16px', height: '16px' }} />
                                )}
                                Export Catalogue {selectedCategory !== 'all' && `(${categories.find(c => c.id === selectedCategory)?.name || selectedCategory})`}
                            </button>
                            <button className="action-button secondary">
                                <ShoppingCart style={{ width: '16px', height: '16px' }} />
                                Quick Order
                            </button>
                        </div>
                    </div>

                    {/* Categories Section - UNITECH IKK Cable Management Categories */}
                    <div className="categories-section">
                        <h2 className="section-title">Catégories Systèmes de Câblage UNITECH</h2>
                        <div className="categories-grid">
                            {categories.map((category) => {
                                const IconComponent = getCategoryIcon(category.id);
                                return (
                                    <div
                                        key={category.id}
                                        className={`category-card ${selectedCategory === category.id ? 'active' : ''}`}
                                        onClick={() => setSelectedCategory(category.id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="category-header">
                                            <div className="category-icon">
                                                <IconComponent style={{ width: '20px', height: '20px', color: 'white' }} />
                                            </div>
                                            <h3 className="category-name">{category.name}</h3>
                                        </div>
                                        <p className="category-count">{category.count} produits</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Filters Section */}
                    <div className="filters-section">
                        <div className="filters-row">
                            <div className="filter-group">
                                <label className="filter-label">Research</label>
                                <input
                                    type="text"
                                    className="filter-input"
                                    placeholder="Name, SKU, material, supplier..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Trier par</label>
<select
    className="filter-select"
    value={sortBy}
    onChange={(e) => setSortBy(e.target.value)}
>
    <option value="productNumber">Product</option>
    <option value="barcodeNumber">Barcode</option>
    <option value="category">Category</option>
    <option value="standard">Standard</option>
    <option value="updatedAt">Last Updated</option>
</select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Ordre</label>
                                <select
                                    className="filter-select"
                                    value={sortOrder}
                                    onChange={(e) => setSortOrder(e.target.value)}
                                >
                                    <option value="asc">Croissant</option>
                                    <option value="desc">Décroissant</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Actions</label>
                                <button className="action-button secondary">
                                    <Filter style={{ width: '16px', height: '16px' }} />
                                    Filtres avancés
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Cable Products Table */}
                    <div className="products-table-section">
                        <div className="table-header">
                            <h2 className="table-title">
                                {selectedCategory === 'all' ? 'Tous les produits câblage' : 
                                 categories.find(c => c.id === selectedCategory)?.name || 'Produits câblage'}
                            </h2>
                            <span className="table-stats">
                                {pagination.total} produit{pagination.total > 1 ? 's' : ''} trouvé{pagination.total > 1 ? 's' : ''}
                                {isLoading && ' (chargement...)'}
                            </span>
                        </div>

<table className="products-table">
    <thead className="table-head">
        <tr>
            <th onClick={() => {
                setSortBy('barcodeNumber');
                setSortOrder(sortBy === 'barcodeNumber' && sortOrder === 'asc' ? 'desc' : 'asc');
            }} style={{ cursor: 'pointer' }}>
                Code-barres {sortBy === 'barcodeNumber' && (sortOrder === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => {
                setSortBy('productNumber');
                setSortOrder(sortBy === 'productNumber' && sortOrder === 'asc' ? 'desc' : 'asc');
            }} style={{ cursor: 'pointer' }}>
                Produit {sortBy === 'productNumber' && (sortOrder === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => {
                setSortBy('category');
                setSortOrder(sortBy === 'category' && sortOrder === 'asc' ? 'desc' : 'asc');
            }} style={{ cursor: 'pointer' }}>
                Catégorie {sortBy === 'category' && (sortOrder === 'asc' ? '↑' : '↓')}
            </th>
            <th>Description</th>
            <th onClick={() => {
                setSortBy('standard');
                setSortOrder(sortBy === 'standard' && sortOrder === 'asc' ? 'desc' : 'asc');
            }} style={{ cursor: 'pointer' }}>
                Standard {sortBy === 'standard' && (sortOrder === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => {
                setSortBy('updatedAt');
                setSortOrder(sortBy === 'updatedAt' && sortOrder === 'asc' ? 'desc' : 'asc');
            }} style={{ cursor: 'pointer' }}>
                Dernière MAJ {sortBy === 'updatedAt' && (sortOrder === 'asc' ? '↑' : '↓')}
            </th>
            <th>Actions</th>
        </tr>
    </thead>
    <tbody className="table-body">
        {cableProducts.map((product) => {
            return (
                <tr key={product._id}>
                    <td>
                        <div className="barcode-info">
                            <div className="barcode-number" style={{ fontFamily: 'monospace', fontWeight: '600' }}>
                                {product.barcodeNumber}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div>
                            <div className="product-name" style={{ fontWeight: '500' }}>
                                {product.productNumber}
                            </div>
                        </div>
                    </td>
                    <td>
                        <span className="category-badge">
                            {categoryOptions.find(c => c.value === product.category)?.label || product.category}
                        </span>
                    </td>
                    <td>
                        <div className="description-cell" style={{ 
                            maxWidth: '400px',
                            whiteSpace: 'normal',
                            lineHeight: '1.5',
                            wordBreak: 'break-word',
                            fontSize: '13px',
                            padding: '4px 0'
                        }}>
                            {product.description}
                        </div>
                    </td>
                    <td>
                        <span className="standard-badge" style={{
                            backgroundColor: '#f3f4f6',
                            color: '#374151',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: '500'
                        }}>
                            {product.standard?.replace('_', ' ') || 'N/A'}
                        </span>
                    </td>
                    <td>
                        {product.updatedAt ? new Date(product.updatedAt).toLocaleDateString('fr-FR') : '-'}
                    </td>
                    <td>
                        <div className="actions-cell">
                            <button 
                                className="action-icon" 
                                title="Voir détails"
                                onClick={() => openViewModal(product)}
                                style={{ cursor: 'pointer' }}
                            >
                                <Eye style={{ width: '16px', height: '16px' }} />
                            </button>
                            {(user.role === 'manager' || user.role === 'admin') && (
                                <button 
                                    className="action-icon edit" 
                                    title="Modifier"
                                    onClick={() => openEditModal(product)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <Edit style={{ width: '16px', height: '16px' }} />
                                </button>
                            )}
                            {user.role === 'admin' && (
                                <button 
                                    className="action-icon delete" 
                                    title="Supprimer"
                                    onClick={() => handleDeleteCableProduct(product._id)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <Trash2 style={{ width: '16px', height: '16px' }} />
                                </button>
                            )}
                        </div>
                    </td>
                </tr>
            );
        })}
    </tbody>
</table>

                        {cableProducts.length === 0 && !isLoading && (
                            <div style={{ 
                                padding: '40px', 
                                textAlign: 'center', 
                                color: '#64748b',
                                borderTop: '1px solid rgba(30, 64, 175, 0.05)'
                            }}>
                                <Cable style={{ width: '48px', height: '48px', margin: '0 auto 16px', opacity: 0.5 }} />
                                <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>
                                    Aucun produit de câblage trouvé
                                </p>
                                <p style={{ fontSize: '14px' }}>
Try modifying your search criteria or filters, or add new UNITECH products.
                                </p>
                            </div>
                        )}

                        {isLoading && (
                            <div style={{ 
                                padding: '40px', 
                                textAlign: 'center', 
                                color: '#64748b'
                            }}>
                                <RefreshCw style={{ 
                                    width: '24px', 
                                    height: '24px', 
                                    margin: '0 auto 16px', 
                                    animation: 'spin 1s linear infinite' 
                                }} />
                                <p>Loading cable products...</p>
                            </div>
                        )}

                        {/* Pagination */}
{pagination.pages > 1 && (
    <div style={{ 
        padding: '20px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        gap: '15px',
        flexWrap: 'wrap'
    }}>
        {/* Bouton Précédent */}
        <button 
            onClick={() => setPagination(prev => ({ ...prev, page: Math.max(1, prev.page - 1) }))}
            disabled={pagination.page === 1}
            style={{
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                background: pagination.page === 1 ? '#f9fafb' : 'white',
                color: pagination.page === 1 ? '#9ca3af' : '#374151',
                cursor: pagination.page === 1 ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s ease'
            }}
        >
            ← Précédent
        </button>

        {/* Navigation par numéros de page */}
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            background: '#f8fafc',
            padding: '8px 12px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0'
        }}>
            {/* Première page */}
            {pagination.page > 3 && (
                <>
                    <button
                        onClick={() => setPagination(prev => ({ ...prev, page: 1 }))}
                        style={{
                            padding: '6px 10px',
                            border: 'none',
                            borderRadius: '4px',
                            background: 'white',
                            color: '#374151',
                            cursor: 'pointer',
                            fontSize: '14px',
                            minWidth: '32px'
                        }}
                    >
                        1
                    </button>
                    {pagination.page > 4 && (
                        <span style={{ color: '#6b7280', fontSize: '14px' }}>...</span>
                    )}
                </>
            )}

            {/* Pages autour de la page actuelle */}
            {Array.from({ length: pagination.pages }, (_, i) => i + 1)
                .filter(page => 
                    page >= Math.max(1, pagination.page - 2) && 
                    page <= Math.min(pagination.pages, pagination.page + 2)
                )
                .map(page => (
                    <button
                        key={page}
                        onClick={() => setPagination(prev => ({ ...prev, page }))}
                        style={{
                            padding: '6px 10px',
                            border: 'none',
                            borderRadius: '4px',
                            background: page === pagination.page ? '#1e40af' : 'white',
                            color: page === pagination.page ? 'white' : '#374151',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: page === pagination.page ? '600' : '500',
                            minWidth: '32px',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        {page}
                    </button>
                ))
            }

            {/* Dernière page */}
            {pagination.page < pagination.pages - 2 && (
                <>
                    {pagination.page < pagination.pages - 3 && (
                        <span style={{ color: '#6b7280', fontSize: '14px' }}>...</span>
                    )}
                    <button
                        onClick={() => setPagination(prev => ({ ...prev, page: pagination.pages }))}
                        style={{
                            padding: '6px 10px',
                            border: 'none',
                            borderRadius: '4px',
                            background: 'white',
                            color: '#374151',
                            cursor: 'pointer',
                            fontSize: '14px',
                            minWidth: '32px'
                        }}
                    >
                        {pagination.pages}
                    </button>
                </>
            )}
        </div>

        {/* Input direct pour aller à une page */}
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            background: '#f8fafc',
            padding: '8px 12px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0'
        }}>
            <span style={{ fontSize: '14px', color: '#374151', fontWeight: '500' }}>
                Aller à:
            </span>
            <input
                type="number"
                min="1"
                max={pagination.pages}
                placeholder={pagination.page}
                style={{
                    width: '60px',
                    padding: '4px 8px',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    fontSize: '14px',
                    textAlign: 'center'
                }}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        const page = parseInt(e.target.value);
                        if (page >= 1 && page <= pagination.pages) {
                            setPagination(prev => ({ ...prev, page }));
                            e.target.value = '';
                        }
                    }
                }}
                onBlur={(e) => {
                    const page = parseInt(e.target.value);
                    if (page >= 1 && page <= pagination.pages) {
                        setPagination(prev => ({ ...prev, page }));
                    }
                    e.target.value = '';
                }}
            />
            <span style={{ fontSize: '12px', color: '#6b7280' }}>
                sur {pagination.pages}
            </span>
        </div>

        {/* Bouton Suivant */}
        <button 
            onClick={() => setPagination(prev => ({ ...prev, page: Math.min(prev.pages, prev.page + 1) }))}
            disabled={pagination.page === pagination.pages}
            style={{
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                background: pagination.page === pagination.pages ? '#f9fafb' : 'white',
                color: pagination.page === pagination.pages ? '#9ca3af' : '#374151',
                cursor: pagination.page === pagination.pages ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s ease'
            }}
        >
            Suivant →
        </button>
    </div>
)}

                    </div>
                </div>
            </main>
        </div>
    );
};

export default UnitechCableManagementPage;